import { useMemo, useState } from "react";
import ProgressSpinner from "../../components/progress_spinner";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import PayTechSupportPlanModal from "./pay_tech_support_plan_modal";

const mockData = [
  {
    project_api_plan_id: "devApiPlanId1",
    project_name: "NETS QR Integration Support",
    on_demand_plan: "$150",
    monthly_plan: "$50",
    annual_plan: "$550",
    is_deleted: 0,
    tech_support_plan: "NETS QR Integration",
    features: [
      "NETS QR Integration",
      "Integration with NETS QR APIs",
      { title: "Supported Payment Methods", items: ["eNETS", "NETS QR"] },
    ],
  },
  {
    project_api_plan_id: "devApiPlanId2",
    project_name: "NETS QR Certification Support",
    on_demand_plan: "$150",
    monthly_plan: "$50",
    annual_plan: "$550",
    is_deleted: 0,
    tech_support_plan: "NETS QR Integration",
    features: [
      "NETS QR Integration",
      "Integration with NETS QR APIs",
      { title: "Supported Payment Methods", items: ["eNETS", "NETS QR"] },
    ],
  },
  {
    project_api_plan_id: "devApiPlanId3",
    project_name: "NETS QR Certification",
    on_demand_plan: "$150",
    monthly_plan: "$50",
    annual_plan: "$550",
    is_deleted: 0,
    tech_support_plan: "NETS QR Certification",
    features: [
      "NETS QR Certification",
      "Support for NETS QR APIs",
      { title: "Supported Payment Methods", items: ["eNETS", "NETS QR"] },
    ],
  },
];

export default function TechSupportPlan({ isMobile }) {
  const [techSupportPlans, setTechSupportPlans] = useState(mockData);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [selectedPlanName, setSelectedPlanName] = useState("");
  const navigate = useNavigate();

  const columns = useMemo(() => [
    {
      Header: "Tech Support Plan",
      accessor: "tech_support_plan",
    },
    {
      Header: "On-Demand Plan",
      accessor: "on_demand_plan",
    },
    {
      Header: "Monthly Plan",
      accessor: "monthly_plan",
    },
    {
      Header: "Annual Plan",
      accessor: "annual_plan",
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <button
          type="button"
          onClick={() => handleGetStarted(row.original.project_name)}
          className={`hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 rounded-full transition-colors duration-200 ${
            isMobile ? 'py-2 px-6 text-sm' : 'py-2 px-12'
          }`}
        >
          Get Started
        </button>
      ),
    },
  ], [isMobile]);

  const handleGetStarted = (planName) => {
    setSelectedPlanName(planName);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handlePay = () => {
    console.log(`Plan selected: ${selectedPlanName}`);
    setOpen(false);
  };

  return (
    <div className="w-full">
      {techSupportPlans.length > 0 ? (
        <>
          {/* Mobile-responsive table container */}
          <div className={`${isMobile ? 'overflow-x-auto' : ''}`}>
            <Table
              columns={columns}
              data={techSupportPlans}
              filters={columns.map((column) => column.accessor)}
              isMobile={isMobile}
            />
          </div>
        </>
      ) : (
        <div className={`${
          isMobile 
            ? 'min-h-64 flex items-center justify-center' 
            : 'w-screen h-screen flex flex-wrap flex-row place-items-center'
        }`}>
          <div className="flex place-content-center w-full">
            <ProgressSpinner className={`${isMobile ? 'w-12 h-12' : 'w-20 h-20'}`} />
          </div>
        </div>
      )}
      
      {/* Modal */}
      <PayTechSupportPlanModal
        isOpen={isOpen}
        setOpenModal={setOpen}
        planName={selectedPlanName}
        isMobile={isMobile}
      />
    </div>
  );
}